// extracted by mini-css-extract-plugin
module.exports = {"Control":"Control_Control__1MH_L"};